const initialState = {
	selectedItems: null
};

export default function priceTags(state = initialState, action) {
  	switch (action.type) {
		case 'SAVE_SELECTED_ITEMS_FOR_PRICE_TAGS':
	    	return { ...state,
				selectedItems: action.data
			};
		case 'RESET_PRICE_TAGS_REDUCERS':
			return initialState;
	  	default:
	    	return state;
  	}
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/priceTags.js